export default __webpack_public_path__ + "static/media/fundraiser-img.2205aa2a.jpg";